/**
 * Confirmar el email con el enlace del correo — `URS §7`, `OD-0018 E-05`.
 *
 * NO se confirma al abrir la página: hace falta pulsar. Los filtros de correo
 * y los antivirus abren los enlaces para analizarlos, y algunos ejecutan
 * JavaScript; si bastara con cargar la página, la cuenta la activaría una
 * máquina y el enlace le llegaría gastado a la persona.
 *
 * La API responde lo mismo para token inexistente, usado o caducado: aquí
 * tampoco se distingue.
 */
import { useState } from "react";
import { api, ESTADO_VALIDACION } from "../api/cliente";
import { t } from "../i18n/es";
import { Aviso, Boton, Tarjeta } from "../ui/primitivas";

export function PantallaVerificarEmail({
  token,
  hayConexion,
  onVerificado,
  onPedirOtro,
  onVolver,
}: {
  token: string | null;
  hayConexion: boolean;
  onVerificado: () => void;
  onPedirOtro: () => void;
  onVolver: () => void;
}) {
  const [enviando, setEnviando] = useState(false);
  const [enlaceMuerto, setEnlaceMuerto] = useState(token === null);
  const [error, setError] = useState<string | null>(null);

  async function confirmar(): Promise<void> {
    if (token === null) return;
    setError(null);
    setEnviando(true);
    const r = await api.verificarEmail(token);
    setEnviando(false);

    if (r.ok) {
      onVerificado();
      return;
    }
    if (r.estado === 0) setError(t.comun.sinRed);
    else if (r.estado === 429) setError(t.comun.demasiadosIntentos);
    else if (r.estado === ESTADO_VALIDACION) setEnlaceMuerto(true);
    else setError(t.comun.errorGenerico);
  }

  if (enlaceMuerto) {
    return (
      <Tarjeta titulo={t.verificar.titulo}>
        <Aviso tono="error">{t.enlace.noValido}</Aviso>
        <div className="acciones">
          <Boton onClick={onPedirOtro}>{t.enlace.pedirOtroRegistro}</Boton>
          <Boton variante="secundario" onClick={onVolver}>
            {t.recuperar.volver}
          </Boton>
        </div>
      </Tarjeta>
    );
  }

  return (
    <Tarjeta titulo={t.verificar.titulo}>
      <p>{t.verificar.detalle}</p>
      {error !== null ? <Aviso tono="error">{error}</Aviso> : null}
      {!hayConexion ? <Aviso tono="aviso">{t.comun.sinRed}</Aviso> : null}
      <div className="acciones">
        <Boton onClick={() => void confirmar()} deshabilitado={enviando || !hayConexion}>
          {enviando ? t.verificar.confirmando : t.verificar.confirmar}
        </Boton>
        <Boton variante="secundario" onClick={onVolver}>
          {t.recuperar.volver}
        </Boton>
      </div>
    </Tarjeta>
  );
}
